import './node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.constructor.mjs';
import './node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.filter.mjs';
import './node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.for-each.mjs';
import './node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.map.mjs';
import './node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/modules/es.iterator.some.mjs';
import { useMemo, useCallback, useContext, createContext } from 'react';
import { Cookies, CookiesProvider, useCookies } from 'react-cookie';
import { throwContextError } from './utils.mjs';
import { jsx } from 'react/jsx-runtime';

const Context = /*#__PURE__*/createContext({
  allowedKeys: [],
  allowedPrefixes: [],
  validateKey: () => true
});
const checkAllowed = (key, allowedKeys, allowedPrefixes) => {
  return allowedKeys.some(allowedKey => allowedKey === key) || allowedPrefixes.some(allowedPrefix => key.startsWith(allowedPrefix));
};
const filterCookies = (cookies, allowedKeys, allowedPrefixes) => {
  return cookies ? cookies.split('; ').map(cookie => cookie.split('=', 2)).filter(_ref => {
    let [key] = _ref;
    return checkAllowed(key, allowedKeys, allowedPrefixes);
  }).map(_ref2 => {
    let [key, value] = _ref2;
    return `${key}=${value}`;
  }).join('; ') : '';
};
function SafeCookiesProvider(_ref3) {
  let {
    cookies,
    allowedKeys = [],
    allowedPrefixes = [],
    debug = process.env.NODE_ENV !== 'production',
    children
  } = _ref3;
  const providerCookies = useMemo(() => {
    const filteredCookies = filterCookies(cookies, allowedKeys, allowedPrefixes);
    if (debug && typeof window !== 'undefined') {
      console.info(`[🍪][사용가능한 쿠키목록]`);
      console.table(filteredCookies.split('; '));
    }
    return new Cookies(filteredCookies);
  }, [debug, cookies, allowedKeys, allowedPrefixes]);
  const validateKey = useCallback(key => {
    const isAllowed = checkAllowed(key, allowedKeys, allowedPrefixes);
    if (!isAllowed && debug) {
      throw Error(`허용되지 않은 KEY가 요청되었습니다. ${key}를 사용하려면 allowedKeys에 등록해주세요.`);
    }
    return isAllowed;
  }, [debug, allowedKeys, allowedPrefixes]);
  return /*#__PURE__*/jsx(Context.Provider, {
    value: {
      allowedKeys,
      allowedPrefixes,
      debug,
      validateKey
    },
    children: /*#__PURE__*/jsx(CookiesProvider, {
      cookies: providerCookies,
      children: children
    })
  });
}
const useSafeCookies = keys => {
  const context = useContext(Context);
  if (context === undefined) {
    throwContextError('SafeCookiesProvider', 'useSafeCookies');
  }
  const {
    validateKey,
    debug
  } = context;
  const [cookies, setCookie, removeCookie] = useCookies(keys);
  const validatedCookies = useMemo(() => {
    keys?.forEach(key => {
      validateKey(key);
    });
    return cookies;
  }, [keys, validateKey, cookies]);
  const setSafeCookie = useCallback((key, value, options) => {
    if (validateKey(key)) {
      debug && console.info(`[🍪]["${key}" 수정] ${value}  ${options ? '(options: ' + JSON.stringify(options) + ')' : ''} `);
      setCookie(key, value, options);
    }
  }, [validateKey, debug, setCookie]);
  const removeSafeCookie = useCallback((key, options) => {
    if (validateKey(key)) {
      debug && console.info(`[🍪]["${key}" 제거] ${options ? '(options: ' + JSON.stringify(options) + ')' : ''} `);
      removeCookie(key, options);
    }
  }, [validateKey, debug, removeCookie]);
  return useMemo(() => [validatedCookies, setSafeCookie, removeSafeCookie], [validatedCookies, setSafeCookie, removeSafeCookie]);
};

export { SafeCookiesProvider, filterCookies, useSafeCookies };
